import { configureStore } from '@reduxjs/toolkit';

import { imageErrorsReducer } from './features';
import { useAppDispatch, useAppSelector } from './hooks';

const store = configureStore({
  reducer: {
    imageErrors: imageErrorsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export { store, useAppDispatch, useAppSelector };
